import { useMainKeyVisualAndKeyVisuals } from "@/components/features/_hooks/use-main-kv-and-kvs";

import { useProductDummyRoomFormModelContext } from "../../../../context";

export const useRoomKeyVisual = () => {
	const { viewModel, onSetViewModel } = useProductDummyRoomFormModelContext();
	const { mainKeyVisual, keyVisuals } = viewModel;

	return useMainKeyVisualAndKeyVisuals({
		mainKeyVisual,
		keyVisuals,
		onSetMainKeyVisual: onSetViewModel,
		onSetKeyVisuals: onSetViewModel,
	});
};
